export default "__VITE_ASSET__80dae74f__"